import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../constant.js";
const Notification = () => {
  const [data, setData] = useState("");
  useEffect(() => {
    getdata();
  }, [data]);
  const getdata = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);

    const result = await axios.post(
      baseUrl + `authController/getNotificationList`,
      formData,
    );
    console.log(result);
    setData(result.data);
  };
  return (
    <>
      <section className="online_trade_view">
        <div className=" text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body p-0">
                  <div className="dashboard_main">
                    <div className="dashboard_header">
                      <div>
                        <Link to="/seeting">
                          <i className="fa fa-angle-left"></i>
                        </Link>
                      </div>
                      <div>
                        <h4>Notification</h4>
                      </div>
                      <div>
                        <div className="ui_dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="edit-profile.html"
                              >
                                My Profile
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Logout
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="market_tab_col">
                      <div className="tab-content dashboard_col_tabs">
                        {data
                          ? data.data.map((item) => (
                              <div
                                className="market_trades_colm wallet_history_tab"
                                style={{ margin: "5px" }}
                              >
                                <div className="history_tab_list">
                                  <ul>
                                    <li style={{ fontSize: "16px" }}>
                                      {item.message}
                                    </li>
                                  </ul>
                                  <ul>
                                    <li>{item.created}</li>
                                  </ul>
                                </div>
                              </div>
                            ))
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Notification;
